module.exports = __webpack_public_path__ + "static/swing_logo-ecb7915e0a58fc9347f661d4fa7349de.png";